export default __webpack_public_path__ + "static/media/miezeProfile.f4da42b5.png";